import _ from "lodash";
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { planTypes } from '@/common/constants';
import { isZoomPhone } from '@/common/service/computers/plans/pbx';
import { getBasePlanInfo } from "../product";

export const boughtPlanFilter = (getters) => {
  const boughtPlans = getters.boughtPlans || [];
  const boughtBasePlanInfo = getBasePlanInfo(boughtPlans);
  const { type, editConfig = {} } = pageConfig;
  const planType = editConfig?.planType;

  switch (type) {
    case flowTypes.add2cart: 
      // FREE TRIAL - in add flow no need free trial plan
      return boughtPlans.filter((item) => (
        (!item.isFreeTrial && !item.isOnlineFreeTrial) ||
        planType !== item.type
      ));
    case flowTypes.edit: {
      if (isZoomPhone(planType) || planType === planTypes.TOLLFREE) {
        return boughtPlans.filter(item => item.type !== planType);
      } else {
        // filter current plan
        return boughtPlans.filter(item => item.plan_code !== getters.oldPlanCode);
      }
    }
    case flowTypes.edu2esc:
    case flowTypes.biz2pro:
    case flowTypes.pro2biz:
    case flowTypes.pro2bundle:
    case flowTypes.biz2bundle:
    case flowTypes.pro2prop:
    case flowTypes.esc2escp:
      // If meeting upgrade to others, remove old meeting plan.
      return boughtPlans.filter(item => item.type !== planTypes.ZOOM_MEETING);
    case flowTypes.trial2paid:
      // FREE TRIAL - isOnlineFreeTrial: new free trial with paid plan code, isFreeTrial: old free trial with separate trial code
      return boughtPlans.filter((item) => !item.isFreeTrial && !item.isOnlineFreeTrial);
    case flowTypes.mixBuy:
      // MIX_BUY
      // filter have purchased plans with mix buy flow
      const editPlanTypes = getters.mixBuyPlanType4FlowType?.[flowTypes.edit];
      return boughtPlans.filter(item => !_.includes(editPlanTypes, item?.type));
    case flowTypes.upgrade:
    case flowTypes.downgrade:
      return boughtPlans.filter(item => item.type !== boughtBasePlanInfo.planType);
    default:
      return boughtPlans;
  }
};
